import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smooth-scrollbar',[_c(VProgressLinear,{attrs:{"indeterminate":""}}),_c(VSkeletonLoader,{attrs:{"type":"card-avatar, article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }